import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import Stack from '../stack/Stack';
import { Tick } from '../icon/icons/Tick';
import Typography from '../typography/Typography';

// Interface

export interface MiniTicksProps {
  items?: string[];
  tickColor?: 'lime' | 'lilac';
}

// Styles

const StyledMiniTickItem = styled(Typography)`
  ${({ theme: { space, colors, media } }) => css`
    display: flex;
    align-items: center;
    gap: ${space.xxxSmall};
  `};
`;

// JSX

export const MiniTicks: FC<MiniTicksProps> = ({ items, tickColor }) => {
  if (!items) {
    return null;
  }
  return (
    <Stack as="ul" gap="xxxSmall">
      {items?.map((item, index) => (
        <StyledMiniTickItem component="li" variant="bodyBold" key={index}>
          <Tick size="small" color={tickColor || 'lime'} /> {item}
        </StyledMiniTickItem>
      ))}
    </Stack>
  );
};

export default MiniTicks;
